<template>
  <div class="hello">

    <RouterLink class="mr-2 border" to="/" >Go to Home</RouterLink>
    <RouterLink class="mr-2 border" to="/shop" >Shop</RouterLink>
    <RouterLink class="mr-2 border" to="/contact" >contact</RouterLink>
    <RouterLink class="mr-2 border" to="/About" >About</RouterLink>

    <h3>Contact.vue</h3>

    <button @click="GoToHome">go to Home</button>


  </div>
</template>

<script>
import { useRouter  } from "vue-router";

export default {
  name: 'HelloWorld',
  data(){
    return{
      router:useRouter()
    }

  },
  props: {
    msg: String
  },
  methods: {
     GoToHome()
      {


        console.log(this.router)
        this.router.push('/');
      }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
